import commonService from '@/common/service/commonService'

export default {
  state: {
    user: {  }
  },
  mutations: {
    setUserInfo(state, info) {
      const { user } = state
      state.user = Object.assign({}, user, info )
    }
  },
  actions: {
    setInfoAction({  state, commit, rootState }, info) {
      const { userId } = rootState || ''
      return commonService.saveUserInfo({ userId, ...info })
      .then(res=> {
        commit('setUserInfo', info)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js